module.exports = require('./helpers/bundle-url').getBundleURL('cQKSD') + "lexus-arrow.36b38b69.png";